<template>
  <div>
    <div>
      <div class="title">
        <gl-sub-text>棚割最大パターン</gl-sub-text>
      </div>
      <div class="content input-inline">
        <md-field class="input-inline__field input-inline__field--small">
          <md-input v-model.number="_tanaNum" type="number" min="2"></md-input>
        </md-field>
        <label class="input-inline__label">本パターン</label>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

/**
 * TapirMk用オプション選択コンポーネント
 */
export default {
  mixins: [ErrorReport],
  props: {
    /**
     * 棚割最大パターン
     */
    tanaNum: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    _tanaNum: {
      get() {
        return this.tanaNum
      },
      set(newVal) {
        this.$emit('update:tanaNum', newVal)
      },
    },
    /**
     * 入力エラー
     */
    errors() {
      const errors = []

      // 棚割パターンは自然数
      if (this._tanaNum < 1) {
        errors.push('棚割最大パターンは1以上を入力してください。')
      } else if (!Number.isInteger(this._tanaNum)) {
        errors.push('棚割最大パターンは整数で入力してください。')
      }

      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}

.radio-buttons {
  display: flex;

  &.vertical {
    flex-direction: column;
  }
}
</style>
